export const defineNetworkAdapter = (adapter) => adapter;
